import languages from 'constants/enum/languages'
import ZodConfig from 'constants/zodConfig'
import {z} from 'zod'

const signupField = {
    email: {
        name: 'email',
        rules: {required: true},
        variant: 'standard',
        type: 'email',
    },
    password: {
        name: 'password',
        rules: {required: true},
        variant: 'standard',
        type: 'password',
    },
    confirmPassword: {
        name: 'confirmPassword',
        rules: {required: true},
        variant: 'standard',
        type: 'password',
    },
    firstName: {
        name: 'firstName',
        rules: {required: true},
        variant: 'standard',
        type: 'text',
    },
    lastName: {
        name: 'lastName',
        rules: {required: true},
        variant: 'standard',
        type: 'text',
    },
    phoneNumber: {
        name: 'phone',
        rules: {required: true},
        variant: 'standard',
        type: 'text',
    },
}

const language = {
    name: 'language',
    rules: {required: true},
    variant: 'standard',
    type: 'select',
    options: languages.LANGUAGES,
    xs: 12,
}

const signupFieldValidation = z.object({
    email: ZodConfig.string().email({message: 'email'}),
    password: ZodConfig.string().min(6, {message: 'password'}),
    confirmPassword: ZodConfig.string().min(6, {message: 'confirmPassword'}),
    firstName: ZodConfig.string(),
    lastName: ZodConfig.string(),
    phone: ZodConfig.string().min(6, {message: 'phone'}),
})

const signupFieldSection = {
    createUser: {
        items: {
            firstName: {
                ...signupField.firstName,
                xs: 12,
                sm: 6,
            },
            lastName: {...signupField.lastName, xs: 12, sm: 6},
            email: {...signupField.email, xs: 12},
            phoneNumber: {...signupField.phoneNumber, xs: 12},
            Language: language,
        },
    },
}
export {signupField, signupFieldValidation, signupFieldSection}
